import { Component } from '@angular/core';

/**
 * Component that sets the ids for the svg icons
 */
@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html'
})
export class SvgComponent {
  constructor() { }
}
